import React, { Component } from 'react';
import '../assets/custom.css';
import LoginFields from '../LoginFields/LoginFields';
import { withRouter } from 'react-router-dom';
import logo from "../assets/images/logo_avenuepm.png";
import logo_ideasthatwork from "../assets/images/logo-bottom.png";
import REST from "../Shared/REST";
import DialogBox from "../Shared/DialogBox";
import pinIcon from "../assets/images/pin.png";
const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30%'
    }
};

class ResetPasswordComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            resetEmail: '',
            resetType: "username",
            email: "",
            submitting: false,
            usernameEmailError: '',
            passwordEmailError: '',
            errorEmailNoteUsername: '',
            errorEmailNotePassword: '',
            modalDialog:false,
            responseContent:'',
            analytics: {
                type: null,
                metadata: null,
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSelf = this.closeModalSelf.bind(this);
        this.resetSubmit = this.resetSubmit.bind(this);
        this.handleResetEmailChange = this.handleResetEmailChange.bind(this);
        this.changePasswordSubmit = this.changePasswordSubmit.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    async componentDidMount(){
        let token = await localStorage.getItem('token');
        if (token) {
            await REST.authWithToken().then((response) => {
                if (response.success) {
                    console.log(response);
                    this.props.history.push('/');
                }
            });
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal() {
        this.setState({ isModalOpen: false, email:"" });
    }

    closeModalSelf(e) {
        e.stopPropagation();
        this.setState({ showModal: false});
    }

    handleChange(event) {
        this.setState({ username: event.target.value, password: this.state.password });
    }

    handleResetEmailChange(event) {
        this.setState({email:event.target.value.toLowerCase()});
    }

    async handleSubmit(event) {
        await this.setState({
            username: this.state.username.toString()
        })
        if (!this.state.username) {
            this.setState({
                modalDialog: true,
                responseContent:'User name is required!',
                infoWarning: null

            });
            return;
        }
        if (!this.state.password) {
            this.setState({
                modalDialog: true,
                responseContent:'Password is required!',
                infoWarning: null

            });
            return;
        }
    }


    validate() {
        let valid = true;
        if(this.state.resetType === "username"){
            if(this.state.email === null || this.state.email.length === 0){
                valid = false;
                this.setState({usernameEmailError: 'validationRed' });
            }
            else{
                this.setState({usernameEmailError: '' });
            }
        }
        else{
            if(this.state.email === null || this.state.email.length === 0){
                valid = false;
                this.setState({passwordEmailError: 'validationRed' });
            }
            else{
                this.setState({passwordEmailError: '' });
            }

        }
        return valid;
        //TODO: check email for regex
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    resetSubmit(type) {
        this.setState({
            submitting:true
        });
        if(type==="password") {
            if(this.validate()) {
                this.setState({errorEmailNotePassword: '' });
                REST.resetPassword({email: this.state.email}).then((res) => {
                    this.setState({errorEmailNotePassword: '', passwordEmailError: '',modalDialog: true, responseContent: 'An email with the password has been sent to the email provided.',infoWarning: null});
                    this.closeModal();
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                    this.setState({
                        submitting: false
                    });
                }).catch((e) => {
                    this.setState({
                        submitting: false,
                        errorEmailNotePassword: 'Invalid email provided.'
                    });
                });
            } else {
                this.setState({
                    submitting: false
                });
                this.setState({errorEmailNotePassword: 'Email address format is invalid' });
            }
        }else{
            if(this.validate()) {
                this.setState({errorEmailNoteUsername: '' });
                REST.resetUsername({email: this.state.email}).then((res) => {
                    this.setState({errorEmailNoteUsername: '', usernameEmailError: '',modalDialog: true, responseContent:'An email with the username has been sent to the email provided.',infoWarning: null});
                    this.closeModal();
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                    this.setState({
                        submitting: false
                    });
                }).catch((e) => {
                    this.setState({
                        submitting: false,
                        errorEmailNoteUsername: 'Invalid email provided.'
                    });
                });
            }
            else{
                this.setState({
                    submitting: false
                });
                this.setState({errorEmailNoteUsername: 'Email address format is invalid' });
            }
        }
    }

    async changePasswordSubmit() {

        if(this.state.newpassword.length>0 && this.state.newpassword===this.state.confirmpassword) {
            await this.setState({
                submitting: true
            });
            await REST.changePassword({
                emailGUID: this.state.emailGUID,
                password: this.state.newpassword
            }).then(async(res) => {
                await this.closePasswordModal();
                await this.setState({
                    submitting: false,
                    username: res.body.username,
                    password: this.state.newpassword,
                    modalDialog: true,
                    responseContent:'Password Changed Successfully.',
                    infoWarning: null

                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.tryLogin();},3500);
            }).catch((e) => {
                this.setState({
                    submitting: false,
                    modalDialog: true,
                    responseContent:'Invalid data provided.',
                    infoWarning: null
                });
                this.closePasswordModal();
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }else {
            this.setState({
                modalDialog: true,
                responseContent:'Please fill out all fields correctly.',
                infoWarning: null

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        }
    }

    handleLoginEnterKeyPress = (event) => {
        if(event.key == 'Enter'){
            this.handleSubmit();
        }
    }

    render() {
        return (
            <div>
                <h1 className="homePage"><img src={logo} alt="AvenuePM" border="0" /></h1>
                <div className="section bgGreen mainLogin">
                    <div className="container">
                        <div>
                            <h2 className="width">Reset Password</h2>
                            <div className="formContainer">
                                <div>
                                    <div id="pinIcon">
                                        <img src={pinIcon} alt="Pin Icon" border="0"/>
                                    </div>
                                    <div className="formLogin">
                                        <div className="input-title">Please input your email</div>
                                        <input type="text" value={this.state.email} className="form-control"
                                               onChange={this.handleChange} placeholder="Email"
                                               onKeyPress={this.handleLoginEnterKeyPress} required autoFocus/>
                                        <br/>
                                        <div className={"row"}>
                                            <div className={"col-md-12 col-xs-12"}>
                                                <div className={"row"}>
                                                    <button onClick={this.handleSubmit} name="Login"
                                                            className="btn btn-primary loginButton">Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <DialogBox notificationModal modalOpen={this.state.modalDialog}
                                               infoWarning={this.state.infoWarning}
                                               sectionContent={this.state.responseContent} htmlSection
                                               closeClick={(active) => {
                                                   this.setState({modalDialog: active});
                                               }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <footer>
                    <div className="container">
                        <div className="col-lg-12">
                            <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the North Carolina State University and Penn State University. (v.1.0.2)</p>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default withRouter(ResetPasswordComponent);